import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { filter, map, tap } from 'rxjs';

import { SignupStateActions } from '../../../../actions/signup-state.actions';
import { HubspotService } from '../hubspot.service';

import { HubspotActions } from './hubspot.actions';

@Injectable()
export class HubspotEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private cookieService = inject(CookieService);
  private hubspotService = inject(HubspotService);

  checkForHubspotCookie$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SignupStateActions.checkEmail),
      filter(() => !!this.cookieService.get('hubspotutk')?.length),
      map(({ email }) => HubspotActions.createHubspotAccount({ email }))
    )
  );

  createHubspotAccount$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(HubspotActions.createHubspotAccount),
        tap(action => {
          const { email } = action;
          this.hubspotService.identifyContact(email);
        })
      ),
    { dispatch: false }
  );

  setHubspotPath$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(HubspotActions.setHubspotPath),
        tap(action => {
          const { path } = action;
          this.hubspotService.setPath(path);
        })
      ),
    { dispatch: false }
  );

  setCompanyDetails$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SignupStateActions.setCompanyDetails),
        tap(() => {
          this.hubspotService.setPath('Signup-CompanyDetails');
        })
      ),
    { dispatch: false }
  );

  setAccountDetails$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SignupStateActions.setAccountDetails),
        tap(() => {
          this.hubspotService.setPath('Signup-AccountDetails');
        })
      ),
    { dispatch: false }
  );
}
